(function () {
  "use strict";
  const selectors = {
    rowsHolder: "[data-timeline-rows]",
    row: "[data-timeline-row]",
    rowEditor: "[data-timeline-row-editor]",
    button: "[data-timeline-button]",
    blockScroll: "[data-block-scroll]",
  };
  const classes = { selected: "is-selected" };

  if (customElements.get("timeline-component")) return;

  customElements.define(
    "timeline-component",
    class TimelineComponent extends HTMLElement {
      constructor() {
        super();
        this.rows = this.querySelectorAll(selectors.row);
      }

      connectedCallback() {
        if (this.rows.length < 2) return;

        this.rowsWidth = 0;
        this.rowsHeight = [];
        this.buttons = this.querySelectorAll(selectors.button);
        this.rowsHolder = this.querySelector(selectors.rowsHolder);
        this.requestAnimation = null;
        this.isDesktopView = !theme.isMobile;
        this.isScrollEnabled = false;

        this.scrollEvent = (e) => this.scrollEvents(e);
        this.resizeEvent = () => this.resizeEvents();

        this.measure();

        if (this.isDesktopView && !this.isScrollEnabled) {
          this.isScrollEnabled = true;
          document.addEventListener("theme:scroll", this.scrollEvent);
        }

        this.rowsHolder.addEventListener("scroll", this.scrollEvent);
        document.addEventListener("theme:resize:width", this.resizeEvent);

        // Ricalcola quando immagini/font finiscono di caricare, cosi'
        // sezioni lunghe (molti blocchi) non si disallineano dallo scroll reale
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);
        window.addEventListener("load", () => this.measure());

        if (this.buttons.length) {
          this.buttons.forEach((button, index) => {
            button.addEventListener("click", (event) => {
              event.preventDefault();
              const row = event.currentTarget.closest(selectors.row);
              if (!row) return;

              if (theme.isMobile) {
                const gap = 16;
                const left = row.offsetLeft - gap;
                this.rowsHolder.scrollTo({ left, behavior: "smooth" });
              } else {
                const maxRowHeight = Math.max(...this.rowsHeight);
                const step = this.holderHeight / this.rows.length;
                const top = this.getBoundingClientRect().top;
                const target =
                  (index > 0 && maxRowHeight < step ? step * index + top : top) + 1;
                window.theme.scrollTo(target);
              }
            });
          });
        }
      }

      measure() {
        this.calculateRowsDimensions();
        this.holderTop = this.getBoundingClientRect().top + window.scrollY;
        this.holderHeight = this.offsetHeight;
        this.requestAnimation = requestAnimationFrame(() => this.calculatePosition());
      }

      resizeEvents() {
        this.measure();
        const isDesktop = !theme.isMobile;
        if (isDesktop && !this.isScrollEnabled) {
          this.isScrollEnabled = true;
          document.addEventListener("theme:scroll", this.scrollEvent);
        } else if (!isDesktop && this.isScrollEnabled) {
          this.isScrollEnabled = false;
          document.removeEventListener("theme:scroll", this.scrollEvent);
        }
      }

      scrollEvents(event) {
        if (this.requestAnimation) return;
        const target = event.currentTarget;
        this.requestAnimation = requestAnimationFrame(() => this.calculatePosition(target));
      }

      removeAnimationFrame() {
        if (this.requestAnimation) {
          cancelAnimationFrame(this.requestAnimation);
          this.requestAnimation = null;
        }
      }

      calculateRowsDimensions() {
        if (!this.rows.length) return;
        this.rowsHeight = [];
        this.rowsWidth = 0;
        let offset = 0;

        this.rows.forEach((row, index) => {
          this.rowsHeight.push(row.offsetHeight);
          this.rowsWidth += row.offsetWidth + parseInt(getComputedStyle(row).marginRight);

          if (window.Shopify.designMode) {
            const editors = this.querySelectorAll(selectors.rowEditor);
            if (editors.length) {
              offset += row.offsetHeight;
              editors[index]?.style.setProperty("--row-height-min", `${row.offsetHeight}px`);
              editors[index + 1]?.style.setProperty("--row-top-mobile", `${offset}px`);
            }
          }
        });
      }

      calculatePosition(scrollTarget = null) {
        this.removeAnimationFrame();
        this.holderTop = this.getBoundingClientRect().top + window.scrollY;

        const isDesktop = !theme.isMobile;
        const step = this.holderHeight / this.rows.length;
        let cumulative = this.holderTop;
        const viewportHeight = window.innerHeight;

        // Abbassa questo valore (es. 1 o 0.75) se vuoi che la riga resti
        // "bloccata" finche' non copre la viewport prima di cambiare.
        const lookAhead = 1.5;
        const scrollPoint = window.scrollY + lookAhead * viewportHeight;

        let mobilePercent = 0;
        if (!isDesktop && scrollTarget) {
          const scrolled = scrollTarget.scrollLeft - 16;
          const width = scrollTarget.offsetWidth;
          mobilePercent = (scrolled / (this.rowsWidth - width)) * 100;
          this.style.setProperty("--percent-mobile", `${mobilePercent}%`);
        }

        if (
          isDesktop &&
          (scrollPoint < this.holderTop ||
            scrollPoint > this.holderTop + this.holderHeight + viewportHeight)
        ) {
          return;
        }

        this.rows.forEach((row, index) => {
          if (index > 0) {
            const rowPercent = (row.offsetLeft / this.rowsWidth) * 100;
            let isActive = mobilePercent > rowPercent;

            if (isDesktop) {
              isActive = cumulative + step < scrollPoint;
              if (cumulative - step < scrollPoint) {
                row.previousElementSibling?.style.setProperty(
                  "--percent-desktop",
                  `${((scrollPoint - cumulative) / step) * 100}%`
                );
              }
            }
            row.classList.toggle(classes.selected, isActive);
          }
          cumulative += step;
        });
      }

      disconnectedCallback() {
        if (this.isScrollEnabled) {
          this.isScrollEnabled = false;
          document.removeEventListener("theme:scroll", this.scrollEvent);
        }
        this.rowsHolder?.removeEventListener("scroll", this.scrollEvent);
        document.removeEventListener("theme:resize:width", this.resizeEvent);
        this.resizeObserver?.disconnect();
      }

      onBlockSelect(event) {
        const holder = this.querySelector(selectors.blockScroll);
        if (!holder) return;
        const source = event.srcElement;
        const index = [...source.parentElement.children].indexOf(source);
        const row = this.rows[index];
        if (row) {
          holder.scrollTo({ top: 0, left: row.offsetLeft, behavior: "smooth" });
        }
      }
    }
  );
})();